import { useIntl } from 'react-intl';
import Edit from 'src/componentes/edit/edit-dialog';
import Geral from './geral';
import { Schema } from 'src/utils/form';

const schema = Schema.object({
  idIntegracao: Schema.string().required(),
  dataInicio: Schema.string().required(),
  dataTermino: Schema.string(),
  faixaFarol: Schema.string().required(),
});

const EditForm = (props) => {
  return <Geral props={props} />;
};

const EditView = (props) => {
  const intl = useIntl();

  return (
    <Edit
      {...props}
      url="/ItemFaixaFarol"
      title={intl.formatMessage({ id: 'faixaDeFarol' })}
      schema={schema}
      formComponent={EditForm}
      width="60%"
      height={500}
      intl={intl}
      showExport={false}
    />
  );
};

export default EditView;
